import { createSlice } from "@reduxjs/toolkit";

import { setLocalStorage } from "shared/utils/Utils";

export const RegionReducer = createSlice({
  name: "Region",
  initialState: {
    token: null,
  },
  reducers: {
    setToken: (state, action) => {
      let region = action.payload;
      if (region) {
        setLocalStorage("region", region);
      }
      return { ...state, token: region };
    },
    reset(state) {
      setLocalStorage("region", null);
      return { ...state, token: null };
    },
  },
  extraReducers: {},
});
